import React, { useContext, useEffect, useState } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { SnackbarHandlerContext, SnackbarMessage } from 'context/SnackbarContext';
import _ from 'lodash';

function Alert(props: AlertProps) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		width: '100%',
		'& > * + *': {
			marginTop: theme.spacing(2)
		}
	}
}));

const Message = ({
	onClose,
	message,
	clean
}: {
	onClose: (key?: string) => (event?: React.SyntheticEvent, reason?: string) => void;
	message: SnackbarMessage;
	clean: () => void;
}) => {
	useEffect(() => {
		return () => clean();
	}, [message]);
	return (
		<Alert onClose={onClose(message?.key)} severity={message?.type}>
			{message?.message}
		</Alert>
	);
};

export const SnackbarContainer = () => {
	const classes = useStyles();
	const [isOpen, setOpen] = React.useState(false);
	const { messages, remove } = useContext(SnackbarHandlerContext);

	const [message, setMessage] = useState<SnackbarMessage | undefined>();

	const close = () => setOpen(false);

	const onClose = (key?: string) => (_?: React.SyntheticEvent, reason?: string) => {
		if (reason === 'clickaway') return;
		if (key) remove(key);
		close();
	};

	useEffect(() => {
		if (!messages) return close();
		if (!_.first(messages)) return close();
		setMessage(_.first(messages));
		setOpen(true);
	}, [messages]);

	return (
		<div className={classes.root}>
			<Snackbar
				anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				open={isOpen}
				autoHideDuration={3000}
				onClose={onClose(message?.key)}
			>
				{message && <Message clean={() => setMessage(undefined)} message={message} onClose={onClose}></Message>}
			</Snackbar>
		</div>
	);
};
